import styled from "styled-components";

const Button = ({ children, onClick, variant, width }) => {
  return (
    <ButtonStyled variant={variant} width={width} onClick={onClick}>
      {children}
    </ButtonStyled>
  );
};

export default Button;

const ButtonStyled = styled.button`
  background: ${({ variant }) =>
    variant === "primary" ? "white" : "transparent"};
  border: 1px solid white;
  border-radius: 5px;
  color: ${({ variant }) =>
    variant === "primary" ? "hsl(229, 25%, 31%)" : "white"};
  cursor: pointer;
  font-weight: 700;
  outline: none;
  padding: 0.7rem 2rem;
  transition: transform 0.5s ease;
  ${({ width }) => (width ? `width: ${width};` : null)}

  :active {
    transform: scale(0.9);
  }
  :hover {
    ${({ variant }) => variant === "primary" && "color: hsl(349, 70%, 56%)"}
  }
`;
